import styled from 'styled-components';

import { DatePicker } from '@dreryk/react-components';

export const StyledDatePicker = styled(DatePicker)`
   width: 345px;
`;

StyledDatePicker.displayName = 'StyledDatePicker';
